import React from 'react';
import styles from './FoodCategoryBadge.module.scss';

import { IFood } from './Food';
import { getFoodCategory } from './FoodCategory';
import { useTranslation } from 'features/translator';

interface FoodCategoryBadgeProps {
  data: IFood;
}

const FoodCategoryBadge: React.FunctionComponent<FoodCategoryBadgeProps> = ({ data }) => {
  const translation = useTranslation();
  const category = getFoodCategory(data);

  if (!category.id) {
    return null;
  }

  const translatedLabel = (function (id: string) {
    switch (id) {
      case 'vegan':
        return translation.get('foods', 'vegan');
      case 'vegetarian':
        return translation.get('foods', 'vegetarian');
      case 'fish':
        return translation.get('foods', 'lunch');
      case 'dessert':
        return translation.get('foods', 'dessert');
      case 'special':
        return translation.get('foods', 'special');
      case 'sideDish':
        return translation.get('foods', 'sideDish');
      case 'tiedote':
        return translation.get('foods', 'announcement');
      case 'lunch':
        return translation.get('foods', 'lunch');
      default:
        return category.label;
    }
  })(category.id);

  return (
    <span className={`${styles.badge} ${styles[category.id]}`}>
        {translatedLabel}
    </span>
  );
};

export default FoodCategoryBadge;
